<template>
	<div>
		<h1>Payment Information.vue</h1>
	</div>
</template>

<script>
	export default {

	}
</script>



// WEBPACK FOOTER //
// src/pages/merchant/PaymentInformation.vue